import React, { useState } from "react";
import s from "./TableWrapper.module.scss";
import Filters from "../Filters";
import PendingRequestsTable from "../PendingRequestsTable";
import useSWR from "swr";
import { PaginatedGetPendingRequestType } from "../../../../../../../../libs/Utils/Types/NumberManagement";
import { swrFetcher } from "../../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../../libs/api/userSession";

function TableWrapper() {
  const token = UseAuthToken();
  const [search, setSearch] = useState<string>();
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [status, setStatus] = useState<
    "" | "approved" | "rejected" | "pending"
  >("");
  const handlePage = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };
  const { data, isLoading, mutate } = useSWR<
    PaginatedGetPendingRequestType,
    any,
    any
  >(
    token
      ? [
          "api/admin/phone-numbers/requests",
          token,
          {
            ...(search && { search }),
            ...(page && { page }),
            ...(pageSize && { limit: pageSize }),
            ...(status && { status: status }),
          },
        ]
      : null,
    swrFetcher,
  );
  return (
    <div className={s.wrapper}>
      <div className={s.filterWrapper}>
        <Filters
          handleTableSearch={setSearch}
          pageSize={pageSize}
          totalDocs={10}
          handlePageChange={handlePage}
          handleStatus={setStatus}
        />
      </div>
      <PendingRequestsTable
        data={data?.data ?? []}
        isLoading={isLoading}
        mutate={mutate}
      />
    </div>
  );
}

export default TableWrapper;
